import React, { useEffect, useState } from 'react'
import { Trans } from '@lingui/macro'
import Select from '../../../../../../components/common/select/Select'
import { EnrolmentTargetTypeEnum } from 'shared/enums/campaigns'
import { upperFirst } from 'lodash'
import {
  EnrolmentCreationMethodEnum,
  TargetEnrolmentStatusEnum
} from 'front-end/src/graphql/private/PrivateSchemaTypes'
import { SelectEntitiesForm } from 'front-end/src/components/common/selectEntitiesForm'
import { Box, Flex } from 'front-end/src/components'
import { css } from '@emotion/react'
import {
  FETCH_ENTITY_MAP,
  getEnrolmentStateOptionsCertMap,
  getEnrolmentStateOptionsMap,
  getTargetEntitiesTranslations,
  renderStatusLabel,
  transformToSelectOptions
} from '../../CampaignAudienceHelpers'
import { EditCampaignEnrolmentCreatedByRow } from 'front-end/src/pages/manage-campaign-page/components/campaign-audience/modals/enrolment-modal/EditCampaignEnrolmentCreatedByRow'
import { useEditCampaignFilterContext } from 'front-end/src/pages/manage-campaign-page/components/campaign-audience/modals/enrolment-modal/EditCampaignFilterContext'
import { EditCampaignFilterDate } from 'front-end/src/pages/manage-campaign-page/components/campaign-audience/modals/EditCampaignFilterDate'

export function EditCampaignEnrolmentFilterModalBody({
  setSelectedIds,
  selectedIds,
  targetEntityType
}: {
  setSelectedIds: (ids: number[]) => any
  selectedIds: number[]
  targetEntityType: EnrolmentTargetTypeEnum
}) {
  const { editedFilter, setEditedFilter } = useEditCampaignFilterContext()
  const enrolmentStateOptions = transformToSelectOptions(
    targetEntityType === EnrolmentTargetTypeEnum.certification
      ? getEnrolmentStateOptionsCertMap()
      : getEnrolmentStateOptionsMap()
  )

  const [selectedEnrolmentStateType, setSelectedEnrolmentStateType] =
    useState<TargetEnrolmentStatusEnum>(
      editedFilter.enrolmentFilterSetup?.enrolmentFilterType ||
        TargetEnrolmentStatusEnum.any_status
    )

  const isNoEnrolment =
    selectedEnrolmentStateType === TargetEnrolmentStatusEnum.no_enrolment ||
    selectedEnrolmentStateType ===
      TargetEnrolmentStatusEnum.not_completed_or_no_enrolment

  const isLastViewed =
    selectedEnrolmentStateType === TargetEnrolmentStatusEnum.last_viewed_at

  const temporalComparator = !isNoEnrolment
    ? editedFilter.temporalComparator
    : null

  useEffect(() => {
    setEditedFilter({
      ...editedFilter,
      temporalComparator,
      enrolmentFilterSetup: {
        creationMethod:
          editedFilter.enrolmentFilterSetup?.creationMethod ||
          EnrolmentCreationMethodEnum.shareOrSelfAssign,
        includeArchived:
          editedFilter.enrolmentFilterSetup?.includeArchived || false,
        ...editedFilter.enrolmentFilterSetup,
        enrolmentFilterType: selectedEnrolmentStateType
      }
    })
  }, [selectedEnrolmentStateType])

  return (
    <>
      <Flex mt="16px" mb="8px">
        <Flex
          mr="16px"
          align="center"
          justify="flex-end"
          w="164px"
          textAlign="right"
          lineHeight="20px"
        >
          {renderStatusLabel(selectedEnrolmentStateType)}
        </Flex>

        <Box>
          <Select
            options={enrolmentStateOptions.filter(
              (option) =>
                option.value !== TargetEnrolmentStatusEnum.expired_or_expires
            )}
            value={enrolmentStateOptions.find(({ value }) => {
              return value === selectedEnrolmentStateType
            })}
            css={css`
              .Select__control {
                min-width: 400px;
              }
            `}
            aria-label={`${upperFirst(targetEntityType)} enrolment`}
            onChange={(option) => {
              setSelectedEnrolmentStateType(option?.value)
            }}
          />
        </Box>
      </Flex>

      {!isNoEnrolment && (
        <EditCampaignFilterDate
          setSelectedEnrolmentStateType={setSelectedEnrolmentStateType}
        />
      )}

      {!isLastViewed &&
        targetEntityType !== EnrolmentTargetTypeEnum.certification && (
          <EditCampaignEnrolmentCreatedByRow />
        )}

      <Box mb="8px" mt="32px">
        <Trans>
          in any of these {getTargetEntitiesTranslations()[targetEntityType]}
        </Trans>
      </Box>

      <SelectEntitiesForm
        setSelectedIds={setSelectedIds}
        selectedIds={selectedIds}
        entityType={FETCH_ENTITY_MAP[targetEntityType]}
      />
    </>
  )
}
